/* eslint-disable camelcase */
import { CompositeScreenProps, useFocusEffect, useIsFocused } from "@react-navigation/native"
import { observer } from "mobx-react-lite"
import moment from "moment"
import { Box, Icon, Modal, Spinner, useDisclose, View } from "native-base"
import numeral from "numeral"
import React, { FC, memo, ReactElement, useCallback, useEffect, useMemo, useRef, useState } from "react"
import {
  ActivityIndicator,
  Appearance,
  Dimensions,
  Linking,
  Platform,
  RefreshControl,
  ScrollView,
  TouchableOpacity,
  ViewStyle,
  ImageStyle, InteractionManager,
} from "react-native"
import {
  AlertActionsheet,
  AutoImage,
  Button,
  FlatList,
  FormControl,
  Image,
  Intercom,
  JalaIcon,
  JalaLoading,
  JalaWebView,
  ListNetworkError,
  ListRenderItem,
  ListRenderItemInfo,
  ModelPicker,
  OfflineMode,
  OnboardModal,
  OneSignal,
  QuickInputActionsheet,
  Screen,
  Text,
  WalkthroughElement,
  OfflineModeIndicator
} from "../../../components"
import { Farm } from "../../../database"
import { translate, TxKeyPath } from "../../../i18n"
import { useStores } from "../../../models"
import { BatchStoreModel } from "../../../models/app-store/farm-store/batch-store/batch-store"
import { FarmStoreModel } from "../../../models/app-store/farm-store/farm-store"
import {
  HomeNavigatorParamList,
  LoginStack,
  LoginStackVerificationAfterLogin,
  navigate,
  onBottomTabsPressed,
  push,
  resetRoot
} from "../../../navigators"
import { color, images, nativeBaseTheme } from "../../../theme"
import { delay } from "../../../utils/delay"
import codePushCheck from "../../../utils/code-push"
import inAppUpdateCheck from "../../../utils/in-app-update"
// import { delay } from "../../../utils/delay"
import JalaAnalytic from "../../../utils/jala-analytic"
import _ from "lodash"
import I18n from "i18n-js"
// import { useOnResumeHandler } from "../../../utils/on-resume-handler"
import { activateKeepAwake, deactivateKeepAwake } from "@sayem314/react-native-keep-awake"
import { handleDeepLink } from "../../../utils/handle-deep-link"
import MaterialIcons from "react-native-vector-icons/MaterialIcons"
import {
  HomeAutoFeederPondNavigatorParamList
} from "../../../navigators/home/auto-feeder-pond/auto-feeder-pond-navigator"
import { CONSTANTS, JSHmac } from "react-native-hash"
import config from "../../../utils/config"

const alertModeCultivation = require('./alert-mode-cultivation.png')

const ROOT: ViewStyle = {
  flexGrow: 1
}

const FLEX: ViewStyle = {
  flex: 1
}

const TOP_BAR_TITLE_CONTAINER: ViewStyle = {
  justifyContent: "center",
}

const TOP_BAR_CONTAINER: ViewStyle = {
  justifyContent: "center",
}

const REFRESH_BUTTON: ViewStyle = {
  paddingHorizontal: 16,
  paddingLeft: 0
}

const NOTIFICATION_BUTTON: ViewStyle = {
  paddingHorizontal: 16,
  paddingLeft: 0
}

const FORM_DROPDOWN: ViewStyle = {
  paddingHorizontal: 16,
}

const BANNER_CONTENT_CONTAINER: ViewStyle = {
  paddingLeft: 16
}

const BANNER_IMAGE = {
  height: 168,
  width: 312,
  borderRadius: 8
}

const TUTORIAL_ITEM: ViewStyle = {
  flexDirection: 'row',
  backgroundColor: color.palette.gray100,
  paddingLeft: 10,
  paddingVertical: 14,
  marginBottom: 10,
  alignItems: 'center',
  borderRadius: 10,
  borderWidth: 1,
  borderColor: color.palette.gray200
}

const BUTTON_EMPTY_SECTION: ViewStyle = {
  borderRadius: 38,
  paddingHorizontal: 16
}

const BUTTON_START_CULTIVATION_SECTION: ViewStyle = {
  borderRadius: 38,
  paddingHorizontal: 16,
  marginBottom: 8
}

const ACTIVITY_HEADER_CONTAINER: ViewStyle = {
  position: 'absolute',
  top: 0,
  width: '100%',
  paddingHorizontal: 16,
  paddingVertical: 8,
  backgroundColor: color.palette.ocean200,
  alignItems: 'center',
  justifyContent: "space-between",
  flexDirection: "row",
  zIndex: 1
}

const LEFT_HEADER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const RIGHT_HEADER: ViewStyle = {
  borderRadius: 20,
  backgroundColor: color.palette.white,
  padding: 2
}

const MENU_IMAGE: ImageStyle = {
  width: 32,
  height: 32,
  resizeMode: 'contain'
}

const MENU_LIST: ViewStyle = {
  paddingLeft: 16,
  paddingVertical: 8
}

const ICON_MENUS = {
  width: 56,
  height: 56,
  resizeMode: 'cover'
}

const IMAGE_MENU = {
  width: 270,
  height: 100,
  resizeMode: 'cover'
}

const START_CULTIVATION_IMAGE: any = {
  _height: 183,
  _width: 328,
  width: Dimensions.get('window').width - 32,
  get height() {
    return this._height * (this.width / this._width)
  }
}

const bannerInterest = [
  { image: images.banner1, link: 'https://t.me/joinchat/OCBsJShz0WEzMmFl', mixpanelKey: 'Mobile app: Home - click join telegram' },
  { image: images.banner2, link: 'https://jala.tech/pro', mixpanelKey: 'Mobile: promo card - 01' },
  { image: images.banner3, link: 'https://jala.tech/id/baruno/', mixpanelKey: 'Mobile: promo card - 02' },
  { image: images.banner4, link: 'https://app.jala.tech/harga_udang/create', mixpanelKey: 'Mobile: promo card - 03' },
  { image: images.banner5, link: 'https://forms.gle/ExugeCava4cuzKkW7', mixpanelKey: 'Mobile: promo card - 04' },
  { image: images.banner6, link: 'https://jala.tech/platinum-members/', mixpanelKey: 'Mobile: promo card - 05' },
  { image: images.banner7, link: 'https://app.jala.tech', mixpanelKey: 'Mobile: promo card - 06' },
  { image: images.banner8, link: 'https://wa.me/6281325514194?text=Halo Jala, Saya tertarik dengan produk Jala Dojeto dan Dojeto Max', mixpanelKey: 'Mobile: promo card - 07' }
];

const JALA_LOGO: ImageStyle = {
  width: 90,
  height: 40,
  resizeMode: "contain"
}

const activityMenu = require("./activity.png")
const predictionMenu = require("./chemical-icon.png")
const horn = require("./horn.png")

export const HomeTitle: FC = observer(function HomeTitle() {
  return <View style={TOP_BAR_TITLE_CONTAINER}>
    <AutoImage source={images.logo_white} style={JALA_LOGO} />
  </View>
})

export const HomeRefresh: FC<CompositeScreenProps<any,any>> = observer(function HomeRefresh(props) {
  const { route } = props;
  const { homeStore, appStore } = useStores();

  const onPress = useCallback(() => {
    if (route) {
      if (route.name === "Home.Home") homeStore.onRefresh()
      else if (route.name === "Home.Monitoring") homeStore.onRefreshBatch();
    }
    appStore.checkNetworkConnection().catch()
  }, [appStore, homeStore, route])

  return (
    <View style={TOP_BAR_CONTAINER}>
      <TouchableOpacity style={REFRESH_BUTTON} onPress={onPress}>
        <JalaIcon name="refresh" size={24} color={color.palette.white}/>
      </TouchableOpacity>
    </View>
  )
})

export const HomeNotification: FC = observer(function HomeNotification() {
  const { homeStore, homeStore: { navigating, unreadNotificationsCount } } = useStores()

  const onNavigate = useCallback(async () => {
    if (navigating) return;
    homeStore.set('navigating', true)
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Notifications' })
    homeStore.set('navigating', false)
  }, [homeStore, navigating])

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (homeStore) {
        homeStore.getUnreadNotificationsCount();
        homeStore.getUnreadConversationCount();
      }
    })
  }, [homeStore]))

  return (
    <View style={TOP_BAR_CONTAINER}>
      <TouchableOpacity style={NOTIFICATION_BUTTON} onPress={onNavigate}>
        <JalaIcon name="notification" size={24} color={color.palette.white}/>
        {!!unreadNotificationsCount && <View rounded="full" size="8px" backgroundColor="red.500" alignSelf="flex-end" mt="-8px" />}
      </TouchableOpacity>
    </View>
  )
})

const ActivityHeader: FC = observer(function ActivityHeader() {
  const {
    appStore: { farmStore },
    homeStore, homeStore: { lastUpdateDay },
    userStore: { hasManagementInterest },
  } = useStores()

  const {
    pondStoreModels,
  } = farmStore || FarmStoreModel.create({});

  const [ showHeader, setShowHeader ] = useState<boolean>(false)

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      const today = moment().format('YYYY-MM-DD')
      let activeCycles = []
      if ( pondStoreModels.length !== 0 ) {
        const cycleStoreModels = pondStoreModels.filter((pondStoreModel) => pondStoreModel.cycleStoreModels.length !== 0)
        cycleStoreModels.map((pondStore) => {
          const cycle = pondStore.lastCycleStore && {
            ...pondStore.lastCycleStore.cycle
          }
          if ( cycle.finished_at === null ) activeCycles = [...activeCycles, cycle]
          return cycle
        })
        if (activeCycles.length !== 0 && lastUpdateDay !== today)
          setShowHeader(true)
        else setShowHeader(false)
      }
    })
  }, [farmStore, lastUpdateDay, pondStoreModels])

  const onNavigate = useCallback(() => {
    const today = moment().format('YYYY-MM-DD')
    homeStore.set('lastUpdateDay', today)
    setShowHeader(false)
    JalaAnalytic.log('Mobile App: Activity Reminder Pressed')
    InteractionManager.runAfterInteractions(() => {
      navigate('App.Stack', 'Home.Stack', { screen: 'Home.Activity.List' as keyof HomeNavigatorParamList })
    })
  }, [homeStore])

  const onClose = useCallback(() => {
    const today = moment().format('YYYY-MM-DD')
    setShowHeader(false)
    homeStore.set('lastUpdateDay', today)
    JalaAnalytic.log('Mobile App: Activity Reminder Pressed', { dismissed: true })
  }, [homeStore])

  return (showHeader && hasManagementInterest && <View height="45px" zIndex={1}>
    <View style={ACTIVITY_HEADER_CONTAINER}>
      <TouchableOpacity style={LEFT_HEADER} onPress={onNavigate}>
        <AutoImage source={horn} style={MENU_IMAGE} />
        <Text tx="homeScreen.reminderActivity" color={color.palette.gray800} preset="caption2" marginLeft="12px" />
      </TouchableOpacity>
      <TouchableOpacity style={RIGHT_HEADER} onPress={onClose}>
        <JalaIcon name="close" size={20} color={color.palette.blueJalaBase} />
      </TouchableOpacity>
    </View>
  </View>)
})

const FarmPicker: FC<{ colorScheme?: "light"|"dark" }> = memo(observer(function FarmPicker(props) {
  const { colorScheme = Appearance.getColorScheme() } = props
  const {
    appStore, appStore: { farmId, farmStore, loadingFarm }
  } = useStores()

  const { initiating, farm } = farmStore || FarmStoreModel.create({})
  const { name } = farm || {}

  const onFarmChange = useCallback(async (value) => {
    appStore.set('farmId', value || null)
    InteractionManager.runAfterInteractions(() => {
      if (appStore.farmStore) {
        if ((appStore.farmStore.pondStoreModels || []).length === 0) {
          appStore.farmStore.initWithLastBatchAndWaterQualityMultiMeasurements()
        } else {
          appStore.farmStore.initialInitWithLastBatchAndWaterQualityMultiMeasurements()
        }
      }
    })
  }, [appStore])

  const modelPickerActionsheetProps = useMemo(() => ({
    isUseButton: true,
    colorScheme: colorScheme,
    buttonTx: 'quickInput.createFarm' as TxKeyPath,
    onPressBottomButton: () => {
      JalaAnalytic.log('Mobile app: create farm button');
      navigate('App.Stack', 'Home.Stack', {
        screen: 'Home.Farm.Create',
        params: { route: 'create' }
      })
    }
  }), [colorScheme])

  useEffect(() => {
    if (initiating) activateKeepAwake()
    else deactivateKeepAwake();
  }, [initiating])

  return (<View backgroundColor={color.primary}>
    <FormControl
      colorScheme="dark"
      labelTx="homeScreen.farm"
      labelColor={color.palette.white}
      style={FORM_DROPDOWN}
    >
      <View borderRadius="5px" backgroundColor={color.palette.white}>
        <ModelPicker
          key={`${farmId || ''}-${name || ''}-${appStore.farms.length}`}
          colorScheme={"light"}
          actionSheetColorScheme={colorScheme}
          placeholderTx="homeScreen.noFarm"
          Model={Farm}
          value={farmId}
          onValueChange={onFarmChange}
          isDisabled={(initiating || loadingFarm)}
          InputRightElement={(initiating || loadingFarm) && <Spinner mr="9px"></Spinner>}
          pickerActionsheetProps={modelPickerActionsheetProps}
          titleTx="homeScreen.label"
          isUseSearch
        />
      </View>
    </FormControl>
  </View>)
}))

const EmptySection: FC<{
  testID?: string | undefined,
  colorScheme?: "light" | "dark",
  message?: string,
  buttonText?: string,
  onPress?: () => void,
  hideButton?: boolean,
  loading?: boolean
}> = observer(function EmptySection(props) {
  const { testID, colorScheme, message, buttonText, onPress, hideButton, loading } = props

  return (<View
    paddingX="16px"
    paddingTop="8px"
    paddingBottom="8px"
    backgroundColor={color.primary}
  >
    <View
      testID={testID}
      height="208px"
      alignItems="center"
      justifyContent="center"
      borderRadius="4px"
      backgroundColor={color.palette.blue700}
    >
      <Text
        text={!loading ? message : translate('homeScreen.fetchingData')}
        preset="title4"
        marginBottom="14px"
        colorScheme={colorScheme}
        color={color.palette.white}
      />
      {!loading && !hideButton && <Button
        testID="jala:id/empty-section-button"
        text={buttonText}
        preset="primary"
        textPreset="title4"
        colorScheme={colorScheme}
        style={BUTTON_EMPTY_SECTION}
        onPress={onPress}
      />}
      {loading && <View flexDirection="row">
        <ActivityIndicator color={color.palette.white} />
        <Text tx="homeScreen.pleaseWait" preset="title4" marginLeft="12px" color={color.palette.white} />
      </View>}
    </View>
  </View>)
})

const OverviewCard: FC<{
  colorScheme?: "light"|"dark",
  iconBox: string,
  iconName: string,
  iconColor: string,
  title: string,
  value: string,
  unit: string,
  totalActivePonds: number,
  loading?: boolean
}> = observer(function OverviewCard(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    iconBox, iconName, iconColor,
    title, value, unit, totalActivePonds, loading
  } = props;

  const valueColor = loading
    ? (colorScheme === "light" ? "gray.600" : "gray.400")
    : (colorScheme === "light" ? "gray.800" : "gray.200")

  return (
    <View
      height="100px"
      borderRadius="4px"
      borderWidth="1px"
      padding="8px"
      backgroundColor={colorScheme === 'light' ? color.palette.white : nativeBaseTheme.colors.dark["50"]}
      borderColor={colorScheme === "light" ? "gray.200" : "gray.800"}
    >
      <View flexDirection="row" alignItems="center" marginBottom="8px">
        <Box bg={iconBox} size="24px" alignItems="center" justifyContent="center" borderRadius="5px" marginRight="4px">
          <Icon as={JalaIcon} name={iconName} size="20px" color={iconColor} />
        </Box>
        <View flex={1}>
          <Text text={title} preset="body3" colorScheme={colorScheme} isTruncated color={colorScheme === "light" ? "gray.800" : "gray.200"} />
        </View>
      </View>
      <Text colorScheme={colorScheme} numberOfLines={1} isTruncated marginBottom="8px">
        <Text
          text={value || '0'}
          preset="display2"
          marginRight="3px"
          colorScheme={colorScheme}
          color={valueColor}
        />
        {' '}
        <Text text={unit} preset="display2" colorScheme={colorScheme} color={colorScheme === "light" ? "gray.600" : "gray.400"} />
      </Text>
      <View flexDirection="row">
        <Text preset="caption2" numberOfLines={1} isTruncated>
          <Text tx="homeScreen.from" preset="caption2" colorScheme={colorScheme} color={colorScheme === "light" ? "gray.700" : "gray.300"} />
          <Text text={`${totalActivePonds || '-'}`} preset="caption2" colorScheme={colorScheme} color={colorScheme === "light" ? "gray.700" : "gray.300"} />
          <Text tx="homeScreen.activePonds" preset="caption2" colorScheme={colorScheme} color={colorScheme === "light" ? "gray.700" : "gray.300"} />
        </Text>
      </View>
    </View>
  )
})

const Overview: FC<{ testID?: string | undefined, colorScheme?: "light"|"dark" }> = observer(function Overview(props) {
  const { testID, colorScheme = "light" || Appearance.getColorScheme() } = props
  const { appStore: { farmStore } } = useStores()
  const {
    activeBatchStore = BatchStoreModel.create(), farm
  } = farmStore || FarmStoreModel.create()
  const { loadingCycleActual, loadingCyclePrediction, isFeedActualWithin4Days } = activeBatchStore

  const isOwner = useMemo(() => (
    farm?.farm_user_role_id === 3
  ), [farm?.farm_user_role_id])

  const totalActivePonds = activeBatchStore.cycles.length

  const onPressOverviewCard = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - overview - biomassOverview');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Overview.Stack' })
  }, [])

  const onPressFeedAccumulationOverviewCard = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - overview - feedOverview');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Overview.Stack', params: { screen: 'Home.Overview.FeedAccumulationActual.List' } })
  }, [])

  const onPressSurvivalRateOverviewCard = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - overview - srOverview');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Overview.Stack', params: { screen: 'Home.Overview.SurvivalRatePrediction.List' } })
  }, [])

  const onPressSellingPriceOverviewCard = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - overview - priceOverview');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Overview.Stack', params: { screen: 'Home.Overview.SellingPricePrediction.List' } })
  }, [])

  return <View backgroundColor={color.primary}>
    <View testID={testID} marginX="16px" marginTop="8px" marginBottom="8px">
      <View flexDirection="row">
        <TouchableOpacity style={FLEX} onPress={onPressOverviewCard}>
          <OverviewCard
            colorScheme={colorScheme}
            iconBox={color.palette.ocean100}
            iconName="biomass"
            iconColor={color.primary}
            title={translate("homeScreen.predictionBiomass")}
            value={numeral(activeBatchStore.predictionTotalWeight).format('0,0.[0]')}
            unit="kg"
            totalActivePonds={totalActivePonds}
            loading={loadingCyclePrediction}
          />
        </TouchableOpacity>
        <View width="8px" />
        <TouchableOpacity style={FLEX} onPress={onPressFeedAccumulationOverviewCard}>
          <OverviewCard
            colorScheme={colorScheme}
            iconBox={color.palette.red300}
            iconName="feeds"
            iconColor={color.palette.red500}
            title={translate("homeScreen.actualFeedAccumulation")}
            value={numeral(activeBatchStore.actualFeedAccumulation).format('0,0.[0]')}
            unit="kg"
            totalActivePonds={totalActivePonds}
            loading={loadingCyclePrediction}
          />
        </TouchableOpacity>
      </View>
      <View height="8px" />
      <View flexDirection="row">
        <TouchableOpacity style={FLEX} onPress={onPressSurvivalRateOverviewCard}>
          <OverviewCard
            colorScheme={colorScheme}
            iconBox={color.palette.orange300}
            iconName="sr-prediction"
            iconColor={color.palette.orange500}
            title={translate("homeScreen.predictionSR")}
            // value={numeral(activeBatchStore.predictionSurvivalRate).format('0,0.[0]')}
            value={numeral(activeBatchStore.predictionSurvivalRate).format('0.[0]')}
            unit="%"
            totalActivePonds={totalActivePonds}
            loading={loadingCycleActual}
          />
        </TouchableOpacity>
        <View width="8px" />
        {isOwner ? <TouchableOpacity style={FLEX} onPress={onPressSellingPriceOverviewCard}>
          <OverviewCard
            colorScheme={colorScheme}
            iconBox={color.palette.green300}
            iconName="price-prediction"
            iconColor={color.palette.green500}
            title={translate("homeScreen.predictionPrice")}
            value={numeral(activeBatchStore.predictionSellingPrice / 1000000).format('0,0.[0]')}
            unit={translate("million")}
            totalActivePonds={totalActivePonds}
            loading={loadingCyclePrediction}
          />
        </TouchableOpacity> : <TouchableOpacity style={FLEX} onPress={onPressOverviewCard}>
          <OverviewCard
            colorScheme={colorScheme}
            iconBox={color.palette.green300}
            iconName="sampling"
            iconColor={color.palette.green500}
            title={translate("homeScreen.predictionWeight")}
            value={activeBatchStore.predictionMinWeight && _.uniq([
              numeral(activeBatchStore.predictionMinWeight).format('0,0.[0]'),
              numeral(activeBatchStore.predictionMaxWeight).format('0,0.[0]'),
            ]).join('-')}
            unit="g"
            totalActivePonds={totalActivePonds}
            loading={loadingCyclePrediction}
          />
        </TouchableOpacity>}
      </View>
    </View>
    {!isFeedActualWithin4Days && <View paddingY="8px" paddingX="16px">
      <Text
        tx="homeScreen.disclaimer"
        preset="title5"
        textAlign="center"
        colorScheme={colorScheme}
        color={color.palette.white}
      />
    </View>}
  </View>
});

const OverviewSection: FC<{ colorScheme?: "light" | "dark" }> = observer(function OverviewSection(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;
  const { appStore: { farmStore, syncedFarm, loadingFarm } } = useStores()
  const {
    pondStoreModels,
    activeBatchStore,
    syncedPond, loadingPond,
    loadingCycle,
    syncedBatch, loadingBatch
  } = farmStore || FarmStoreModel.create()

  const onPressCreateFarm = useCallback(() => {
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Farm.Create' })
  }, [])

  const onPressCreatePond = useCallback(() => {
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Pond.PreCreateMultiple' })
  }, [])

  const onPressCreateCycle = useCallback(() => {
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Cycle.CreateMultiple' })
  }, [])

  if (!farmStore)
    return <EmptySection
      testID="jala:id/empty-farm-section"
      colorScheme={colorScheme}
      message={translate('homeScreen.emptyFarm')}
      buttonText={translate('homeScreen.createFarm')}
      onPress={onPressCreateFarm}
      loading={!syncedFarm || loadingFarm}
    />
  if (!pondStoreModels.length)
    return <EmptySection
      testID="jala:id/empty-pond-section"
      colorScheme={colorScheme}
      message={translate('homeScreen.emptyPond')}
      buttonText={translate('homeScreen.createPond')}
      onPress={onPressCreatePond}
      loading={!syncedPond || loadingFarm || loadingPond}
    />
  if (!activeBatchStore)
    return <EmptySection
      testID="jala:id/empty-cycle-section"
      colorScheme={colorScheme}
      message={translate('homeScreen.emptyCycle')}
      buttonText={translate('homeScreen.createCycle')}
      onPress={onPressCreateCycle}
      loading={!syncedBatch || loadingFarm || loadingPond || loadingCycle || loadingBatch}
    />

  return <Overview
    testID="jala:id/overview-section"
    colorScheme={colorScheme}
  />
})

const MenuItem: FC<{
  colorScheme?: "light" | "dark",
  IconItem?: ReactElement,
  as?: any,
  iconName: string,
  text: string,
  onPress?: () => void
}> = observer(function MenuItem(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    IconItem,
    as = JalaIcon,
    iconName, text,
    onPress
  } = props

  const iconBaseStyle = nativeBaseTheme.components.Icon.baseStyle({ colorMode: colorScheme });

  return (<TouchableOpacity onPress={onPress}>
    <View padding="4px" alignItems="center">
      <View
        width="48px"
        height="48px"
        borderRadius="5px"
        backgroundColor={color.palette.ocean100}
        alignItems="center" justifyContent="center"
      >
        {IconItem || <Icon {...iconBaseStyle} as={as} name={iconName} size="32px" color={color.primary} />}
      </View>
      <Text text={text} preset="body2" marginTop="8px" numberOfLines={1} colorScheme={colorScheme} />
    </View>
  </TouchableOpacity>);
})

const MenuSection: FC<{ colorScheme?: "light" | "dark", scrollViewRef?: any }> = memo(observer(function MenuSection(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), scrollViewRef } = props;
  const { userStore: {
    hasManagementInterest,
    // user,
    isCoachmarkRunning
  }, appStore: { farmStore, locale } } = useStores()
  // const { access_feedo } = user?.state || {};
  const width = Dimensions.get('window').width;
  const menuWidth = (width - 32) / 4

  const onPressMonitoring = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button monitoring');
    if (farmStore && farmStore.activeBatchStore)
      farmStore.set('batchId', farmStore.activeBatchStore.batchId);
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Monitoring' as keyof HomeNavigatorParamList })
  }, [farmStore])

  const onPressPond = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button pond list');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Farm.Pond.List' as keyof HomeNavigatorParamList })
  }, [])

  const onPressActivity = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button activity');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Activity.List' as keyof HomeNavigatorParamList })
  }, [])

  const onPressSimulation = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button simulation');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Simulation.List' as keyof HomeNavigatorParamList })
  }, [])

  const onPressShrimpPrice = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button shrimp prices');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.ShrimpPrice.List' as keyof HomeNavigatorParamList })
  }, [])

  const onPressPost = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button shrimp news');
    push('Home.Stack', {
      screen: 'Home.JalaWebView' as keyof HomeNavigatorParamList,
      params: {
        uri: `https://widgets.jala.tech/${locale === 'id' ? 'id' : 'en'}/blog`,
        title: translate("homeScreen.shrimpNews"),
        backgroundColor: color.palette.white
      }
    });
  }, [locale])

  const onPressDisease = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button disease');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.Disease' as keyof HomeNavigatorParamList })
  }, [])

  const onPressFeedo = useCallback(() => {
    JalaAnalytic.log('Mobile app: home - button asto');
    navigate('App.Stack', 'Home.AutoFeederPond.Stack', { screen: 'Home.Farm.AutoFeederPond.List' as keyof HomeAutoFeederPondNavigatorParamList })
  }, [])

  const onPressChemicalPredictions = useCallback(() => {
    JalaAnalytic.log('Mobile App : Chemical Prediction - Visit');
    navigate('App.Stack', 'Home.Stack', { screen: 'Home.MeasurementPrediction.Stack' as keyof HomeNavigatorParamList })
  }, [])

  return <View padding="16px" marginTop="16px" marginBottom="8px">
    {hasManagementInterest ? <ScrollView horizontal showsHorizontalScrollIndicator={true} persistentScrollbar={true} scrollEnabled={!isCoachmarkRunning}>
      <View alignItems={"flex-start"}>
        <View flexDirection="row" justifyContent="center" marginBottom="16px">
          <WalkthroughElement
            id="monitoring-section"
            scrollViewRef={scrollViewRef}
            scrollOffset={125}
          >
            <View width={`${menuWidth}px`}>
              <MenuItem
                colorScheme={colorScheme} iconName="pc-hp" onPress={onPressMonitoring}
                text={translate("homeScreen.monitoring")}
              />
            </View>
          </WalkthroughElement>
          <View width={`${menuWidth}px`}>
            <MenuItem
              colorScheme={colorScheme} iconName="pond" onPress={onPressPond}
              text={translate("homeScreen.pond")}
            />
          </View>
          <View width={`${menuWidth}px`}>
            <MenuItem
              IconItem={(
                <AutoImage source={activityMenu} style={MENU_IMAGE} />
              )}
              iconName=""
              colorScheme={colorScheme} onPress={onPressActivity}
              text={translate("homeScreen.activity")}
            />
          </View>
          <View width={`${menuWidth}px`}>
            <MenuItem
              colorScheme={colorScheme} iconName="simulation" onPress={onPressSimulation}
              text={translate("homeScreen.simulation")}
            />
          </View>
          {/* {!!access_feedo &&  */}
            <View width={`${menuWidth}px`}>
              <View
                position="absolute" zIndex="1" shadow={2}
                marginTop="-2px" paddingX="4px"  borderRadius="3px"
                backgroundColor="red.600" alignSelf="center"
              >
                <Text preset="label3" colorScheme="dark" tx="homeScreen.beta" />
              </View>
              <MenuItem
                colorScheme={colorScheme} as={MaterialIcons} iconName="timelapse" onPress={onPressFeedo}
                text={translate("homeScreen.asto")}
              />
            </View>
          {/* } */}
        </View>
        <View flexDirection="row" justifyContent="flex-start">
          <View width={`${menuWidth}px`}>
            <MenuItem
              colorScheme={colorScheme} iconName="price" onPress={onPressShrimpPrice}
              text={translate("homeScreen.price")}
            />
          </View>
          <View width={`${menuWidth}px`}>
            <MenuItem
              colorScheme={colorScheme} iconName="news" onPress={onPressPost}
              text={translate("homeScreen.news")}
            />
          </View>
          <View width={`${menuWidth}px`}>
            <MenuItem
              colorScheme={colorScheme} iconName="diseases" onPress={onPressDisease}
              text={translate("homeScreen.disease")}
            />
          </View>
          <View width={`${menuWidth}px`}>
            <View
              position="absolute" zIndex="1" shadow={2}
              marginTop="-2px" paddingX="4px"  borderRadius="3px"
              backgroundColor={color.palette.red} alignSelf="center" flexDirection={"row"}
            >
              <Text preset="label3" colorScheme="dark" text="Beta" />
            </View>
            <MenuItem
              colorScheme={colorScheme}
              IconItem={(
                <AutoImage source={predictionMenu} style={MENU_IMAGE} />
              )}
              iconName=""
              onPress={onPressChemicalPredictions}
              text={translate("homeScreen.predictions")}
            />
          </View>
        </View>
      </View>
    </ScrollView> :  <WalkthroughElement
      id="menu-section-bottom"
      scrollViewRef={scrollViewRef}
      scrollOffset={125}
    >
      <View flexDirection="row" justifyContent="center" marginBottom="16px">
        <View width={`${menuWidth}px`}>
          <MenuItem
            colorScheme={colorScheme} iconName="price" onPress={onPressShrimpPrice}
            text={translate("homeScreen.price")}
          />
        </View>
        <View width={`${menuWidth}px`}>
          <MenuItem
            colorScheme={colorScheme} iconName="news" onPress={onPressPost}
            text={translate("homeScreen.news")}
          />
        </View>
        <View width={`${menuWidth}px`}>
          <MenuItem
            colorScheme={colorScheme} iconName="diseases" onPress={onPressDisease}
            text={translate("homeScreen.disease")}
          />
        </View>
        <View width={`${menuWidth}px`}>
          <View
            position="absolute" zIndex="1" shadow={2}
            marginTop="-2px" paddingX="4px"  borderRadius="3px"
            backgroundColor="red.600" alignSelf="center"
          >
            <Text preset="label3" colorScheme="dark" tx="homeScreen.newLabel" />
          </View>
          <MenuItem
            colorScheme={colorScheme} iconName="simulation" onPress={onPressSimulation}
            text={translate("homeScreen.simulation")}
          />
        </View>
      </View>
    </WalkthroughElement>}
  </View>
}))

const WidgetItem: FC<{ colorScheme?: "light" | "dark", locale: string, item: any, cacheKey?: string, index: number }> = (props) => {
  const { item, colorScheme, cacheKey, index } = props
  const [ error, setError ] = useState(false)
  const [ loading, setLoading ] = useState(true)
  const [ isDelay, setIsDelay ] = useState(false)

  const webViewStyles = useMemo(() => ({
    height: item?.height_in_pixel
  }), [item.height_in_pixel])

  const source = useMemo(() => ({
    uri: item.link
  }), [item.link])

  const onPress = useCallback(() => {
    JalaAnalytic.log('Mobile app: widget pressed', { code: item?.code })
    if (item?.target_url) {
      const deepLinked = handleDeepLink({ url: item.target_url })
      if (!deepLinked) Linking.openURL(item.target_url).catch()
    }
  }, [item])

  const onError = useCallback(() => setError(true), [])

  useEffect(() => {
    delay(index * 700).then(() => {
      setIsDelay(true)
    })
  }, [index])
  return (
    <View>
      <Text marginTop="16px" marginLeft="16px" marginRight="16px" text={item.title} preset="title3" colorScheme={colorScheme} />
      <TouchableOpacity
        activeOpacity={!item.target_url ? 1 : undefined}
        onPress={onPress}
      >
        <View height={`${item.height_in_pixel}px`}>
          { error &&
            <ListNetworkError
              marginTop="16px"
              marginLeft="16px"
              marginRight="16px"
              height={`${item.height_in_pixel - 16}px`}
              backgroundColor={color.palette.backgroundGray}
              borderRadius="4px"
              imageStyles={IMAGE_NETWORK_ERROR}
              onRefresh={() => {
                setError(false)
              }}
            />
          }
          { (!error && cacheKey && isDelay) &&
            <JalaWebView
              style={webViewStyles}
              source={source}
              onError={onError}
              onLoad={({nativeEvent}) => {
                setLoading(nativeEvent.loading)
              }}
              cacheKey={cacheKey}
              renderLoading={null}
            />
          }
          { (loading && !cacheKey) && <View
            height={`${item.height_in_pixel}px`}
            justifyContent={"center"}
            alignItems={"center"}
            position={"absolute"}
            top={0} left={0} right={0} bottom={0}
          >
            <View
              width="72px" height="72px"
              alignItems="center"
              justifyContent="center"
              rounded="48px"
              backgroundColor="rgba(255, 255, 255, 0.75)"
            >
              <JalaLoading />
            </View>
          </View> }
          {(!!item?.target_url && !error) && <View position={"absolute"} zIndex={1} height={`${item?.height_in_pixel}px`} top={0} bottom={0} left={0} right={0} />}
        </View>
      </TouchableOpacity>
    </View>
  )
}

const WidgetSections: FC<{ colorScheme?: "light" | "dark" }> = memo(observer(function WidgetSections(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;
  const { appStore: { locale }, tokenStore, widgetStore: { widgets } } = useStores();
  const [cacheKey, setCacheKey] = useState<string>(null)

  useFocusEffect(useCallback(() => {
    tokenStore.requestCacheKey()
    .then(() => {
      setCacheKey(tokenStore.cacheKey);
    })
  }, [tokenStore]))

  return (
    <View>
      {widgets.map((item, index) => {
        return (
          <WidgetItem
            key={`key-dynamic-${index}`}
            item={item} index={index}
            colorScheme={colorScheme}
            locale={locale} cacheKey={cacheKey}
          />
        )
      })}
    </View>
  )
}))

const IMAGE_NETWORK_ERROR = {
  height: 100,
  width: 100
}

const BannerItem: FC<{ colorScheme?: "light" | "dark", info: ListRenderItemInfo<any> }> = observer(function BannerItem(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;
  const { item: { image, link, mixpanelKey } } = info;

  const onPress = useCallback(() => {
    JalaAnalytic.log(mixpanelKey);
    const deepLinked = handleDeepLink({ url: link })
    if (!deepLinked) Linking.openURL(link).catch()
  }, [link, mixpanelKey])

  return <View
    shadow={2}
    backgroundColor={colorScheme === 'light' ? color.palette.white : nativeBaseTheme.colors.dark["50"]}
    marginRight="16px" marginY="8px" borderRadius="8px">
    <TouchableOpacity onPress={onPress}>
      <Image source={image} style={BANNER_IMAGE} resizeMode="cover" />
    </TouchableOpacity>
  </View>
})

const BannerSection: FC<{ colorScheme?: "light" | "dark", hideTitle?: boolean }> = observer(function BannerSection(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), hideTitle } = props;
  const { homeStore: { sponsors } } = useStores()

  const data = useMemo(() => (
    sponsors && sponsors.length ? sponsors : bannerInterest
  ), [sponsors])

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <BannerItem info={info} colorScheme={colorScheme} />
  }, [colorScheme])

  return (<View>
    {!hideTitle && <View paddingX="16px" paddingY="8px" marginTop="8px">
      <Text tx="homeScreen.bannerTitle" preset="title3" colorScheme={colorScheme} />
    </View>}
    <View height="184px">
      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        data={data}
        renderItem={renderItem}
        ListEmptyComponent={<View height="184px" />}
        contentContainerStyle={BANNER_CONTENT_CONTAINER}
        estimatedItemSize={328}
      />
    </View>
  </View>)
});

const AppMenuSectionItem: FC<{ colorScheme?: "light" | "dark", info: ListRenderItemInfo<any> }> = observer(function AppMenuSectionItem(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), info } = props;
  const { item: {
    code,
    title,
    // subtitle,
    link, mixpanelKey, icon, image
  } } = info;

  const onPress = useCallback(() => {
    JalaAnalytic.log(mixpanelKey, { code });
    const deepLinked = handleDeepLink({ url: link })
    if (!deepLinked) Linking.openURL(link).catch()
  }, [code, link, mixpanelKey])

  return image
    ? <View
      borderRadius="8px"
      height="100px"
      width="270px"
      marginRight="16px"
      overflow="hidden"
      backgroundColor={color.palette.white}
    >
      <TouchableOpacity onPress={onPress}>
        <Image source={image} style={IMAGE_MENU} />
      </TouchableOpacity>
    </View> : <View
      borderRadius="8px"
      marginRight="16px"
      padding="8px"
      alignItems="center"
      width="100px"
      height="100px"
      borderWidth="1px"
      borderColor={color.palette.ocean200}
      backgroundColor={color.palette.white}
    >
      <TouchableOpacity onPress={onPress}>
        <View flex={1} alignItems="center" justifyContent="center">
          <Image source={icon} style={ICON_MENUS} />
        </View>
        <View alignItems="center">
          <Text text={title} preset="body2" marginTop="8px" numberOfLines={1} colorScheme={colorScheme} />
          {/* <Text preset="body3" text={subtitle} colorScheme={colorScheme} color={color.palette.white} numberOfLines={1} isTruncated /> */}
        </View>
      </TouchableOpacity>
    </View>
})

const AppMenuSection: FC<{ colorScheme?: "light" | "dark" }> =memo(observer(function AppMenuSection(props) {
  const { colorScheme } = props;
  const { homeStore: { additionalMenus } } = useStores()

  const renderItem: ListRenderItem<any> = useCallback((info) => {
    return <AppMenuSectionItem colorScheme={colorScheme} info={info} />
  }, [colorScheme])

  if (!additionalMenus || !additionalMenus.length) return null;
  return <View>
    <View paddingX="16px" paddingY="8px">
      <Text preset="title3" tx="homeScreen.appMenusTitle" colorScheme={colorScheme} />
    </View>
    <View height="116px">
      <FlatList
        horizontal
        data={additionalMenus}
        renderItem={renderItem}
        contentContainerStyle={MENU_LIST}
        showsHorizontalScrollIndicator={false}
        estimatedItemSize={286}
      />
    </View>
  </View>
}));

const TutorialSection: FC<{ colorScheme?: "light" | "dark" }> = memo(observer(function TutorialSection(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;

  const onPressYoutube = useCallback(() => {
    Linking.openURL('https://www.youtube.com/watch?v=MCm-MEf9_QQ&list=PLDF2porrO_jy839wyxr8mL6WTQK31Fetw').catch();
  }, [])
  const onPressHelp = useCallback(() => {
    Linking.openURL('https://www.notion.so/Jala-Help-Center-86d9d38190214ed08e5d7c0aa436cf17').catch();
  }, [])
  const onPressTelegram = useCallback(() => {
    Linking.openURL('https://t.me/joinchat/OCBsJShz0WEzMmFl').catch();
  }, [])

  return <View
    paddingTop="24px"
    paddingBottom="10px"
    paddingX="16px"
  >
    <View paddingY="8px">
      <Text
        tx="homeScreen.bottomTitle"
        preset="title3"
        colorScheme={colorScheme}
        color={color.palette[colorScheme === 'light' ? 'gray800' : 'gray200']}
      />
    </View>
    <TouchableOpacity style={TUTORIAL_ITEM} onPress={onPressYoutube}>
      <JalaIcon name="youtube" size={24} color={color.palette.red700} />
      <View flex={1} mx="10px">
        <Text tx="homeScreen.youtubeTutorial" preset="title4" colorScheme={colorScheme} numberOfLines={1} isTruncated />
      </View>
    </TouchableOpacity>
    <TouchableOpacity style={TUTORIAL_ITEM} onPress={onPressHelp}>
      <JalaIcon name="help" size={24} color={color.palette.blue500} />
      <View flex={1} mx="10px">
        <Text tx="homeScreen.helpTutorial" preset="title4" colorScheme={colorScheme} numberOfLines={1} isTruncated />
      </View>
    </TouchableOpacity>
    <TouchableOpacity style={TUTORIAL_ITEM} onPress={onPressTelegram}>
      <JalaIcon name="telegram" size={24} color={color.palette.bluey} />
      <View flex={1} mx="10px">
        <Text tx="homeScreen.telegramTutorial" preset="title4" colorScheme={colorScheme} numberOfLines={1} isTruncated />
      </View>
    </TouchableOpacity>
  </View>
}));

const StartCultivationSection: FC<{ colorScheme?: "light" | "dark" }> = observer(function StartCultivationSection(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props;
  const { isOpen, onOpen, onClose } = useDisclose(false)

  return <>
    <View paddingX="16px" paddingTop="16px">
      <Text
        tx="homeScreen.startCultivationTitle"
        preset="body1"
        textAlign="center"
        marginY="8px"
        colorScheme={colorScheme}
      />
      <View alignItems="center">
        <Button
          testID="jala:id/start-cultivation-button"
          tx="homeScreen.startCultivation"
          preset="primary"
          textPreset="title4"
          colorScheme={colorScheme}
          style={BUTTON_START_CULTIVATION_SECTION}
          onPress={onOpen}
        />
      </View>
    </View>
    <AlertActionsheet
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      colorScheme={colorScheme}
    >
      <View pb="16px" px="16px">
        <Image source={alertModeCultivation} style={START_CULTIVATION_IMAGE} />
        <Text tx="homeScreen.alertStartCultivationTitle" preset="display3" my="8px" colorScheme={colorScheme} />
        <View minHeight="60px">
          <Text tx="homeScreen.alertStartCultivationDescription" preset="body2" colorScheme={colorScheme} />
        </View>
      </View>
    </AlertActionsheet>
  </>;
});

const SetupAlert: FC<{
  colorScheme?: "light" | "dark",
  isOpen: boolean, onOpen?: () => void, onClose?: () => void
}> = observer(function SetupAlert(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    isOpen, onOpen, onClose
  } = props;
  const {
    appStore: { farmStoreModels = [], farmStore },
    userStore: { hasManagementInterest },
  } = useStores()
  const { activePondStores = [] } = farmStore || FarmStoreModel.create({})

  const { titleText, descriptionText } = useMemo(() => {
    if (!hasManagementInterest)
      return {
        titleText: translate('homeScreen.alertStartCultivationTitle'),
        descriptionText: translate('homeScreen.alertStartCultivationDescription')
      }
    if (!farmStoreModels.length)
      return {
        titleText: translate('homeScreen.alertNoFarmTitle'),
        descriptionText: translate('homeScreen.alertNoFarmDescription')
      }
    if (!activePondStores.length)
      return {
        titleText: translate('homeScreen.alertNoActiveCycleTitle'),
        descriptionText: translate('homeScreen.alertNoActiveCycleDescription')
      }
    return { titleText: null, descriptionText: null }
  }, [activePondStores.length, farmStoreModels.length, hasManagementInterest])

  return titleText && (hasManagementInterest ? <AlertActionsheet
    isOpen={isOpen}
    onOpen={onOpen}
    onClose={onClose}
    titleText={titleText}
    descriptionText={descriptionText}
    colorScheme={colorScheme}
  /> : <AlertActionsheet
    isOpen={isOpen}
    onOpen={onOpen}
    onClose={onClose}
    colorScheme={colorScheme}
  >
    <View pb="16px" px="16px">
      <Image source={alertModeCultivation} style={START_CULTIVATION_IMAGE} />
      <Text text={titleText} preset="display3" my="8px" colorScheme={colorScheme} />
      <View minHeight="60px">
        <Text text={descriptionText} preset="body2" colorScheme={colorScheme} />
      </View>
    </View>
  </AlertActionsheet>)
});

export const HomeScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function HomeScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), navigation, route } = props

  // action from navigation
  const action = route.params && route.params.action;

  const {
    appStore, // appStore: { farmStore },
    homeStore, homeStore: { navigating, refreshing },
    tokenStore,
    userStore, userStore: { hasManagementInterest, userLocale, user, skipCoachmark },
    shrimpPriceStore,
    newsStore,
    diseaseStore,
    widgetStore,
  } = useStores()
  const isFocused = useIsFocused();

  const [ isCloseQuickInputTemporary, setIsCloseQuickInputTemporary ] = useState<boolean>(false)
  const [ initialized, setInitialized ] = useState<boolean>(false)

  const scrollViewRef = useRef<ScrollView>(null)

  const {
    isOpen: isOpenQuickInput,
    onOpen: onOpenQuickInput,
    onClose: onCloseQuickInputDisclose
  } = useDisclose(false)

  const activeBatchStoreInit = useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      setInitialized((state) => {
        if (appStore && appStore.farmStore && appStore.farmStore.activeBatchStore && state) {
          appStore.farmStore.activeBatchStore.init();
        }
        return state
      })
    })
  }, [appStore])

  const onCloseQuickInput = useCallback(() => {
    activeBatchStoreInit();
    onCloseQuickInputDisclose();
  }, [activeBatchStoreInit, onCloseQuickInputDisclose])

  useFocusEffect(useCallback(() => {
    appStore.checkNetworkConnection().catch()
  }, [appStore]))

  useEffect(() => {
    if (user) {
      OneSignal.addTriggers({
        "role": user?.role_id || 0,
        "occupation": user?.occupation || "",
      })
    }
  }, [user])

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      if (!tokenStore.token) resetRoot(LoginStack);
      userStore.getUser(false).then(() => {
        if (!userStore.user || !userStore.user.id) return;
        if (userStore.userLocale !== I18n.locale)
          userStore.updateLocale().then(() => userStore.getUser());
        if (!userStore.user.phone_verified) resetRoot(LoginStackVerificationAfterLogin);

        JalaAnalytic.setUserId(userStore.user.id, userStore.user);
        if (userStore.user) {
          OneSignal.setExternalUserId(String(userStore.user.id));
          OneSignal.setEmail(userStore.user.email);
          OneSignal.sendTags({ user_id: userStore.user.id });
          if (Platform.OS !== 'web') {
            Intercom.loginUserWithUserAttributes({
              userId: `${userStore.user.id}`,
              email: userStore.user.email
            }).catch(() => true).then(async () => {
              const { INTERCOM_SECRET_KEY } = config();
              const hmac = await JSHmac(`${userStore.user.id}`, INTERCOM_SECRET_KEY, CONSTANTS.HmacAlgorithms.HmacSHA256);
              await Intercom.setUserHash(hmac)
            }).catch();
          }
        }
      })
    })
  }, [tokenStore.token, userStore])

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      activeBatchStoreInit();
    })
  }, [activeBatchStoreInit]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && userLocale) {
        shrimpPriceStore.set('filterShrimpPrice', {});
        shrimpPriceStore.getShrimpPrices();
      }
    })
  }, [initialized, shrimpPriceStore, userLocale]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && userLocale) newsStore.fetchNews();
    })
  }, [initialized, newsStore, userLocale]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && userLocale) widgetStore.getWidgets();
    })
  }, [initialized, userLocale, widgetStore]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (diseaseStore && initialized) diseaseStore.getDiseases();
    })
  }, [diseaseStore, initialized]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && appStore) appStore.getDiseases()
    })
  }, [appStore, initialized]))

  useFocusEffect(useCallback(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && userLocale) homeStore.fetchAdditionalMenus();
    })
  }, [homeStore, initialized, userLocale]))

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      if (!tokenStore.token) resetRoot(LoginStack);
      homeStore.init()
      if (navigation.isFocused())
        homeStore.initialRefresh().finally(() => {
          setInitialized(true)
        })
      else setInitialized(true);
    })
  }, [appStore, homeStore, navigation, tokenStore])

  useEffect(() => {
    if (Platform.OS === 'web') return undefined;
    Linking.getInitialURL().then((url) => {
      if (url) {
        InteractionManager.runAfterInteractions(() => {
          handleDeepLink({ url })
        })
      }
    })
    const listener = Linking.addEventListener('url', handleDeepLink);
    return () => {
      listener.remove();
    }
  }, [])

  useEffect(() => {
    return onBottomTabsPressed((tabIndex) => {
      if (tabIndex === 2) {
        InteractionManager.runAfterInteractions(() => {
          navigate('App.Stack', 'Home.Home', { tabNavigation: true })
          onOpenQuickInput()
        })
      }
    })
  }, [onOpenQuickInput])

  useFocusEffect(useCallback(() => {
    if (!initialized) return
    setIsCloseQuickInputTemporary(false);
    InteractionManager.runAfterInteractions(() => {
      codePushCheck().catch();
      inAppUpdateCheck().catch()
    })
  }, [initialized]))

  // useOnResumeHandler(useCallback(() => {
  //   if (farmStore && farmStore.lastBatchStore) farmStore.lastBatchStore.init()
  // }, [farmStore]))

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      if (initialized && userLocale) {
        shrimpPriceStore.init();
      }
    })
  }, [shrimpPriceStore, userLocale, initialized])

  useEffect(() => {
    if (action === 'onOpenQuickInput') {
      setIsCloseQuickInputTemporary(false)
      onOpenQuickInput()
    }
  }, [action, onOpenQuickInput])

  const onNavigate = useCallback((screen: any, prediction = null, params = null) => async () => {
    if (navigating) return;
    homeStore.set('navigating', true)
    if (isOpenQuickInput) setIsCloseQuickInputTemporary(true);
    InteractionManager.runAfterInteractions(async () => {
      const stack = screen === 'Help.Help' ? 'App.Stack' : 'Home.Stack'

      switch (screen as keyof HomeNavigatorParamList) {
        case 'Home.Cycle.CreateMultiple':
          JalaAnalytic.log('Mobile app: quick input - create cycle');
          break;
        case 'Home.Sampling.Create':
          JalaAnalytic.log('Mobile app: quick input - sampling');
          break;
        case 'Home.Harvest.Create':
          JalaAnalytic.log('Mobile app: quick input - harvest/partial');
          break;
        case 'Home.Feed.Create':
          JalaAnalytic.log('Mobile app: quick input - feed');
          break;
        case 'Home.WaterQualityMultiMeasurement.Create':
          JalaAnalytic.log('Mobile app: quick input - multi measurements');
          break;
        case 'Home.Treatment.Create':
          JalaAnalytic.log('Mobile app: quick input - treatment');
          break;
        case 'Home.ChemicalMultiMeasurement.Create':
          JalaAnalytic.log('Mobile app: quick input - chemical');
          break;
        case 'Home.MicrobiologyMultiMeasurement.Create':
          JalaAnalytic.log('Mobile app: quick input - microbiology');
          break;
        case 'Home.PlanktonMultiMeasurement.Create':
          JalaAnalytic.log('Mobile app: quick input - plankton');
          break;
        case 'Home.CycleDisease.Create':
          JalaAnalytic.log('Mobile app: quick input - disease');
          break;
        case 'Home.Cycle.CloseMultiple':
          JalaAnalytic.log('Mobile app: quick input - close cycle');
          break;
        case 'Home.Mortality.Create':
          JalaAnalytic.log('Mobile app: quick input - mortality');
          break;
        case 'Home.Farm.Create':
          JalaAnalytic.log('Mobile app: quick input - create farm');
          break;
        case 'Home.Pond.PreCreateMultiple':
          JalaAnalytic.log('Mobile app: quick input - create pond');
          break;
        case 'Home.FeedingTrayControl.CreateMultiple':
          JalaAnalytic.log('Mobile app: quick input - feeding tray');
          break;
      }

      navigate('App.Stack', stack, { screen, ...((params && { params }) || {}) })

      await delay(1);
      if (screen === 'Home.ShrimpPrice.List') {
        JalaAnalytic.log('Mobile app: visit list shrimp prices', { URL: 'Home' });
      }
      homeStore.set('navigating', false)
    })
  }, [homeStore, isOpenQuickInput, navigating])

  return (<>
    <OfflineModeIndicator />
    {!!initialized && <ActivityHeader />}
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.primary : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
      scrollViewRef={scrollViewRef}
      scrollViewProps={{
        refreshControl: (<RefreshControl
          refreshing={refreshing}
          onRefresh={homeStore.onRefresh}
        />),
        scrollEnabled: !!((user?.state?.home_coachmark_shown || skipCoachmark) && user.occupation !== null),
        nestedScrollEnabled: !!((user?.state?.home_coachmark_shown || skipCoachmark) && user.occupation !== null)
      }}
      blurredBackgroundColor={color.palette.white}
      navigationBarBackgroundColor={color.palette.white}
      lazyLoad={false}
      hideOnBlurred={false}
    >
      {hasManagementInterest ? <>
        <WalkthroughElement
          id="farm-and-overview-section"
          scrollViewRef={scrollViewRef}
          scrollOffset={250}
        >
          <FarmPicker colorScheme={colorScheme} />
          <WalkthroughElement
            id="overview-section"
            scrollViewRef={scrollViewRef}
            scrollOffset={250}
          >
            <OverviewSection colorScheme={colorScheme}/>
          </WalkthroughElement>
        </WalkthroughElement>
      </> : <WalkthroughElement
        id="banner-section"
        backgroundColor={color.primary}
        scrollViewRef={scrollViewRef}
        scrollOffset={250}
      >
        <BannerSection hideTitle colorScheme={colorScheme} />
      </WalkthroughElement>}
      <View
        flexGrow={1}
        backgroundColor={color.palette.white}
        marginTop="8px"
        marginBottom={Platform.OS !== 'web' ? "-512px" : undefined}
        paddingBottom={Platform.OS !== 'web' ? "512px" : undefined}
      >
        <WalkthroughElement
          id="menu-section"
          scrollViewRef={scrollViewRef}
          scrollOffset={125}
        >
          {!hasManagementInterest && <StartCultivationSection colorScheme={colorScheme} />}
          <MenuSection colorScheme={colorScheme} scrollViewRef={scrollViewRef} />
        </WalkthroughElement>
        <AppMenuSection colorScheme={colorScheme} />
        <WidgetSections
          colorScheme={colorScheme}
        />
        {hasManagementInterest && <BannerSection colorScheme={colorScheme} />}
        <TutorialSection colorScheme={colorScheme} />
      </View>
      <QuickInputActionsheet
        isOpen={!isCloseQuickInputTemporary && isOpenQuickInput}
        colorScheme={colorScheme}
        onClose={onCloseQuickInput}
        onNavigate={onNavigate}
      />
      <SetupAlert
        colorScheme={colorScheme}
        isOpen={isOpenQuickInput}
        onClose={onCloseQuickInput}
      />
      {isFocused && <Modal isOpen={navigating}>
        <View
          width="72px" height="72px"
          alignItems="center"
          justifyContent="center"
          rounded="48px"
          backgroundColor="rgba(255, 255, 255, 0.75)"
        >
          <JalaLoading />
        </View>
      </Modal>}
    </Screen>
    {initialized && isFocused && <OnboardModal colorScheme={colorScheme} scrollViewRef={scrollViewRef} />}
    <OfflineMode colorScheme={colorScheme} navigation onFinishPushAll={activeBatchStoreInit} />
  </>)
})
